import { render } from "./Cashiers.vue?vue&type=template&id=e51f885a"
import script from "./Cashiers.vue?vue&type=script&lang=js"
export * from "./Cashiers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__